export const DETACH = 'cv/device/DETACH';
export const DETACH_ALL = 'cv/device/DETACH_ALL';
export const DETACH_FAILED = 'cv/device/DETACH_FAILED';
export const DETACH_SUCCEEDED = 'cv/device/DETACH_SUCCEEDED';
